import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  textWhite: {
    color: '#FFFFFF',
  },
  numberBox: {
    fontSize: 40,
    color: '#5F29CC',
    marginTop: theme.spacing(-1.3),
    marginRight: theme.spacing(2),
  },
  containerBoxes: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: theme.spacing(8),

    [theme.breakpoints.down('md')]: {
      display: 'grid',
      justifyItems: 'center',
    },
  },
  mainBox: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: theme.spacing(4),
    backgroundColor: '#FFFFFF',
    borderRadius: 11,
    minWidth: 330,
    minHeight: 280,
  },
  arrowIcon: {
    fontSize: 50,
    color: '#FFFFFF',
    margin: theme.spacing(0, 3),

    [theme.breakpoints.down('md')]: {
      transform: 'rotate(90deg)',
      margin: theme.spacing(3, 0),
    },
  },
  btnStartCreation: {
    backgroundColor: '#5F29CC',
    border: '1px solid #FFFFFF',
    color: '#FFFFFF',
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    borderRadius: 35,

    '&:hover': {
      backgroundColor: '#FFFFFF',
      color: '#7833FF',
    },
  },
}));
